// extracted by mini-css-extract-plugin
export default {"cls1":"QuestionStyles-cls1_Tcn","cls2":"QuestionStyles-cls2_y0p QuestionStyles-cls1_Tcn"};